import React, { useState } from 'react'
import { IconButton } from "@material-ui/core";
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import { Row, Col, Input, InputGroupAddon, InputGroupText, InputGroup, ModalBody,
  Modal,
  ModalFooter,
  FormFeedback,
  ModalHeader } from "reactstrap";
  import Button from "@material-ui/core/Button";
import moment from 'moment';
import { isEmpty, size, isUndefined, filter} from 'lodash';
import {deleteFL142DebitsCall} from "../fl-142/FL142.actions";
import { connect } from 'react-redux';

const FL142SecondSection = (props) => {

    const [inputFields, setInputField] = useState(props.data);

      const [showNote, setShowNote] = useState(false);
  const handleShowNote = () => setShowNote(true);
  const handleCloseNote = () => setShowNote(false);

    const handleChangeInput = (index, event) => {
        const values = [...inputFields];
        values[index][event.target.id] = event.target.value;
        setInputField(values);

    }

    const handleAddFields = () => {
      setInputField((prevFields) => {
        const newFields = [
          ...prevFields,
          {
            debt_description: "",
            debt_sep_prop: "",
            total_owing: "0.0",
            debt_date_incurred: ""
          }
        ];
        props.addField(newFields); 
        return newFields;
      });
    };
    
    const handleRest = (index) => {
        const values = [...inputFields];
        values[index].debt_description = "";
        values[index].debt_sep_prop = "";
        values[index].total_owing = "0.0";
        values[index].debt_date_incurred = "";
        setInputField(values);
        props.addField(values);
    }

    const handleRemoveFields = (index) => {
        const values = [...inputFields];
        if (index = 1)
            values.splice(index, 1);
        setInputField(values);
        props.addField(values);
    }

    const ColoredLine = ({ color }) => (
        <hr
            style={{
                borderTop: "2px solid",
                color: "black",
            }}
        />
    );

    const deleteCall = (id, description, descriptionId) => {
      const fallbackItem = Array.isArray(props.data)
        ? props.data.find(x => x.debt_description === description)
        : null;
    
      if ((isUndefined(id) || isUndefined(descriptionId)) && !fallbackItem) {
        console.error("No matching item found in props.data for description:", description);
        return;
      }
    
      props.deleteFL142DebitsCall({
        divorce_id: window.localStorage.getItem("divorce_id"),
        fl_142_debts_id: isUndefined(id) && fallbackItem ? fallbackItem.fl_142_debts_id : id,
        asset_brief_description_id: isUndefined(descriptionId) && fallbackItem ? fallbackItem.asset_brief_description_id : descriptionId,
      });
    };
    


    const getButtonValue = (e, size) => {
        switch (e) {
          case 17:
            return size < 3 ? true : false;
          case 18:
            return size < 3 ? true : false;
          case 19:
            return size < 3 ? true : false;
          case 20:
            return size < 3 ? true : false;
          case 21:
            return size < 6 ? true : false;
          case 22:
            return size < 12 ? true : false;
        
          default:
            return false;
        }
      }


          const showModal = (e, size) => {
        switch (e) {
          case 17:
          if(size === 2){
          handleShowNote()
        }
        break;
          case 18:
          if(size === 2){
          handleShowNote()
        }
        break;
          case 19:
          if(size === 2){
          handleShowNote()
        }
        break;
          case 20:
          if(size === 2){
          handleShowNote()
        }
        break;
          case 21:
          if(size === 5){
          handleShowNote()
        }
        break;
          case 22:
          if(size === 11){
          handleShowNote()
        }
        break;
        
          default:
            return false;
        }
      }

      const forInvalidCondition = (value) => {
        if(inputFields.length === 1 && inputFields[0].debt_description == "" && inputFields[0].debt_sep_prop == "" && (inputFields[0].debt_date_incurred == "" || inputFields[0].debt_date_incurred == "1947-01-01")){
          return false;
        } else if(inputFields.length > 0 && value == ""){
          return true;
        }
        return false;
      }

    return (
        <div>
            {!isEmpty(inputFields) && inputFields.map((inputField, index) => (
                <div key={index} >

                    <Row>
                        <Col xl={6}>
                            <b>Debts Show to Whom Owed:</b>
                        </Col>
                        <Col xl={12}>
                            <Input style={{ marginLeft: "2px" }} value={inputField.debt_description} type="text" id="debt_description" invalid={forInvalidCondition(inputField.debt_description)}
                                onChange={(e) => {props.handleDescriptionChange(inputFields); handleChangeInput(index, e) }}
                            />
                            <FormFeedback>This field is required.</FormFeedback>
                        </Col>
                    </Row>

                    <Row>
                        <Col xl={4} lg={4} md={12} sm={12} xs={12}>
                            <br></br>
                            <b>Separate Property:</b>
                            <Input type="select" id="debt_sep_prop" value={inputField.debt_sep_prop} invalid={forInvalidCondition(inputField.debt_sep_prop)}
                                onChange={(e) => {props.handleSeparatePropertyChange(inputFields); handleChangeInput(index, e) }}
                                style={
                                  inputField.debt_sep_prop == ""
                                    ? { backgroundImage: "none" } 
                                    : {}
                                }
                            >
                                <option selected value=""> -- select an option -- </option>
                                <option value="1">Yes</option>
                                <option value="0">No</option>
                            </Input>
                            <FormFeedback>This field is required.</FormFeedback>
                        </Col>

                        <Col xl={4} lg={4} md={12} sm={12} xs={12}>
                            <br></br>
                            <b>Total Owing:</b>
                            <InputGroup>
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText>$</InputGroupText>
                                </InputGroupAddon>
                                <Input type="number" id="total_owing" value={inputField.total_owing}
                                    onChange={(e) => {props.handleTotalOwingChange(inputFields); handleChangeInput(index, e) }}
                                />
                                <FormFeedback>This field is required.</FormFeedback>
                            </InputGroup>

                        </Col>

                        <Col xl={4} lg={4} md={12} sm={12} xs={12}>
                            <br></br>
                            <b>Date Incurred:</b>
                            <Input type="date" id="debt_date_incurred" value={(inputField.debt_date_incurred == "1947-01-01") ? "" : moment(inputField.debt_date_incurred).format('YYYY-MM-DD')}
                                invalid={forInvalidCondition(inputField.debt_date_incurred)}
                                onChange={(e) => {props.handleDateIncurredChange(inputFields); handleChangeInput(index, e) }}
                            />
                        </Col>
                    </Row>

                    <Row>
                        <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                        {inputFields.length == 1 ? (
                        <IconButton onClick={() => {handleRest(index); deleteCall(inputField.fl_142_debts_id, inputField.debt_description, inputField.asset_brief_description_id)}} style={{ float: "right", color: "black", marginTop: "15px" }} >
                          <RemoveIcon />
                        </IconButton>
                        ):(
                        <IconButton onClick={() => {handleRemoveFields(index); deleteCall(inputField.fl_142_debts_id, inputField.debt_description, inputField.asset_brief_description_id)}} style={{ float: "right", color: "black", marginTop: "15px" }} >
                          <RemoveIcon />
                        </IconButton>)}

                            {getButtonValue(props.descriptionId, size(inputFields)) && <IconButton onClick={() => {handleAddFields(); showModal(props.descriptionId, size(inputFields))}} style={{ float: "right", color: "black", marginTop: "15px" }}>
                                <AddIcon />
                            </IconButton>}
                        </Col>
                    </Row>
                    <ColoredLine />

                </div>
            ))}
            <Modal isOpen={showNote} style={{ marginTop: "200px", marginLeft: "46%" }}>
        <ModalHeader>
        Note:
        </ModalHeader>
        <ModalBody> If you do not have the options to add more, the court form has run out
           of space. You will need to add a separate attachment. Watch your video tutorials
            for more details.
        </ModalBody>
        <ModalFooter>
        <Row style={{marginLeft:"3px"}}>
        <Button
          style={{width:"48%",marginRight:"2px", color: "white", backgroundColor: "Blue" }}
          onClick={handleCloseNote}
        >
          OK
        </Button>
        </Row>
        </ModalFooter>
      </Modal>
        </div>
    )
}


const mapDispatchToProps = (dispatch) => {
  return {
    deleteFL142DebitsCall: (data) => dispatch(deleteFL142DebitsCall(data)),
  }
}


export default connect(null, mapDispatchToProps)(FL142SecondSection);
